// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__y4pld","spinner":"Loader_spinner__0VmM6","up":"Loader_up__UD7VL","down":"Loader_down__ZtMgg"};